<template>
  <div class="wrapper border-bottom white-bg page-heading">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-lg-10">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else>
            <i class="far fa-user-circle m-r-sm"></i> Account Users

            <template v-if="editingDifferentUser">/ {{ user.profile.full_name }}</template>
          </h1>
        </div>
        <div class="col-xs-2 col-sm-12 col-lg-2">
          <div v-if="canAddAccountUser">
            <div class="text-right m-t-lg" v-if="editingDifferentUser">
              <router-link :to="{ name: 'account.parent.users.create', params: { id: this.user.id }}" class="material-plus">+</router-link>
            </div>
            <div class="text-right m-t-lg" v-else>
              <router-link :to="{ name: 'account.users.create' }" class="material-plus">+</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { existingUser } from 'mixins/user'
  import { mapMutations } from 'vuex'
  import { RESET_ACCOUNT_USER } from 'vx/mutations'
  import { headingLoading } from 'mixins'
  import $ from 'jquery'

  export default {
    mixins: [existingUser, headingLoading],

    computed: {
      canAddAccountUser () {
        if (this.user.isCarrier && this.user.isNotActivated) {
          return false
        }

        return this.user.isEnabled
      }
    },

    methods: {
      ...mapMutations('user/accountUsers', [RESET_ACCOUNT_USER]),

      addNewUser () {
        $('.modal-user-edit').one('show.bs.modal', () => (this[RESET_ACCOUNT_USER]()))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AccountUsersHeading.vue?3d9fa8d1